import Vue from 'vue'
import cronLight from '@vue-js-cron/light'
import '@vue-js-cron/light/dist/light.css'

Vue.use(cronLight)
